import { IconPlus } from '@tabler/icons-react';
import React from 'react';
import { BasicButton, IBasicButtonProps } from 'src/design/atoms/BasicButton';

export type ICreateButtonProps = IBasicButtonProps;

const DefaultProps: Partial<ICreateButtonProps> = {
  variant: 'filled',
  color: 'blue',
  leftSection: <IconPlus size={20} />,
};

/** @registry Filled blue "Create" button with a plus icon; default label "Create". */
export const CreateButton = React.forwardRef<
  HTMLButtonElement,
  ICreateButtonProps
>(({ children = 'Create', ...props }, ref) => {
  return (
    <BasicButton {...DefaultProps} {...props} ref={ref}>
      {children}
    </BasicButton>
  );
});
CreateButton.displayName = 'CreateButton';
